"use strict";
'use client';
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _Autocomplete = _interopRequireDefault(require("@mui/material/Autocomplete"));
var _jsxRuntime = require("react/jsx-runtime");
var warnedOnce = false;
var warn = function() {
    if (!warnedOnce) {
        console.warn([
            'MUI: The Autocomplete component was moved from the lab to the core.',
            '',
            "You should use `import { Autocomplete } from '@mui/material'`",
            "or `import Autocomplete from '@mui/material/Autocomplete'`"
        ].join('\n'));
        warnedOnce = true;
    }
};
/**
 * @ignore - do not document.
 */ var _default = exports.default = /*#__PURE__*/ React.forwardRef(function DeprecatedAutocomplete(props, ref) {
    warn();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Autocomplete.default, _object_spread({
        ref: ref
    }, props));
});
